export enum MobileTypeEnum {
  Android = 'android',
  iOS = 'ios',
  MobileMock = 'mobilemock',
}
